export default __webpack_public_path__ + "static/logo2-85010ae711fa279461941dac3774a6ae.svg";